import {gql} from "@apollo/client";

export const SUBSCRIPTION_ROULETTE = gql`
        subscription RouletteSub {
            v_roulette_drawing {
                 drawCode
                 status
            }
           }`;


